<template>
  <div class="mail_onay container">
    <p class="text-center" v-html="cevap"></p>
  </div>
</template>
<script>
import axios from 'axios'
//import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'

export default {
    name: 'MailOnay',
        data () {
            return {
                islem_url:'https://api2.adalarvakfi.org/kutuphane/mail_kontrol.php',
                //kontrol:this.$route.params.kontrol.replaceAll("æ","/"),
                kontrol:this.$route.params.kontrol,
                cevap:''
            }
          },
          created(){
            this.kontrols()
          },
          methods:{
            kontrols:function(){
            const formData = new FormData()
            formData.append('kontrol', this.kontrol)
            axios({
                method: 'post',
                responseType: 'json',
                url: this.islem_url,
                data: formData
            }).then((response) => {
                    if(!response.data.hata){
                      this.cevap = response.data.cevap
                    }
               })
          }
           
          }
        }
           
</script>
<style>
.mail_onay{
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
p{
  font-size: 1.4rem !important;
}
</style>